import { apiPHP } from '../../services/api';
import type { iGameTemplate } from './context/interfaces';
import type { CrosswordCache, VerifyRequest } from './rules';

export interface PassatempoDetail {
  titulo: string | null;
  texto: string | null;
  estilos_de_passatempos_id?: number | null;
  estilosDePassatemposId?: number | null;
}

/** Registro de GET /passatempos/:id/progresso (`cache` é o último corpo salvo). */
export interface ProgressoRecord {
  id: number;
  usersId?: number;
  passatemposId?: number;
  cache: unknown;
}

export interface VerifyResponse {
  tempo: number;
  acertos: number;
  total: number;
  matrix?: unknown;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export async function getPassatempo(id: number): Promise<PassatempoDetail> {
  const { data } = await apiPHP.get(`/passatempos/${id}`);
  return Array.isArray(data) ? data[0] : data;
}

export async function getGabarito(id: number): Promise<iGameTemplate> {
  const { data } = await apiPHP.get<iGameTemplate>(`/passatempos/${id}/gabarito`);
  return data;
}

/** `null` quando não há progresso (o back responde corpo vazio). */
export async function getProgresso(id: number): Promise<ProgressoRecord | null> {
  const { data } = await apiPHP.get<unknown>(`/passatempos/${id}/progresso`);
  return isRecord(data) ? (data as unknown as ProgressoRecord) : null;
}

export async function saveProgresso(id: number, cache: CrosswordCache): Promise<void> {
  await apiPHP.post(`/passatempos/${id}/progresso`, cache);
}

export async function verificar(id: number, body: VerifyRequest): Promise<VerifyResponse> {
  const { data } = await apiPHP.post<VerifyResponse>(`/passatempos/${id}/verificar`, body);
  return data;
}
